import queryString from 'query-string'
import {
	APP_LOGIN,
	APP_LOGOUT,
	APP_REGISTRATION,
	AUTH_LOGOUT,
	APP_FEEDBACK,
	APP_GET_USER,
	APP_SET_USER,
	APP_ANNOUNCE,
	APP_ALLOWACCESS,
	APP_FEEDBACK_PERSONAL
} from '../constant'

const defaultPOST = {
	method: 'POST',
	headers: {
		'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
		'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
	},
	credentials: 'include',
}

const defaultGET = {
	method: 'POST',
	headers: {
		'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
		'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
	},
	credentials: 'include',
}

const allowaccess  = async (options) => {
	const response = await fetch(APP_ALLOWACCESS, defaultGET)
	return response
};

const login = async (options) => {
	const auth = await getAuth(options)
	const user = await getUser()
	return {...user?.user, ...auth}
}

const getAuth = async (options) => {
	let params = new URLSearchParams()

	for (let key in options) {
		params.append(key, typeof(options[key]) !== 'string' ? JSON.stringify(options[key]) : options[key])
	}

	const merged = Object.assign({}, params, defaultPOST, { body: params })
	const response = await fetch(APP_LOGIN, merged)
	return await response.json()
}

const getUser = async () => {
	const response = await fetch(APP_GET_USER, defaultGET)
	return await response.json()
}


const fetchRegistration = async (options) =>{
	let params = new URLSearchParams()

	for (let key in options) {
		params.append(key, typeof(options[key]) !== 'string' ? JSON.stringify(options[key]) : options[key])
	}

	const merged = Object.assign({}, params, defaultPOST, { body: params })
	const response = await fetch(APP_REGISTRATION, merged)
	return await response.json()
}

const fetchLogout = async () =>{
	const response = await fetch(APP_LOGOUT, defaultGET)
	const result = await response.json()
	if (result.auth === AUTH_LOGOUT) {
		window.location.reload()
	}
}

const sendFeedback = async (options) =>{
	let params = new URLSearchParams()
	for (let key in options) {
		params.append(key, typeof(options[key]) !== 'string' ? JSON.stringify(options[key]) : options[key])
	}

	const merged = Object.assign({}, params, defaultPOST, { body: params })
	const response = await fetch(APP_FEEDBACK, merged)
	return await response.json()
}

const sendFeedbackPersonal = async (options) =>{
	let params = new URLSearchParams()
	for (let key in options) {
		params.append(key, typeof(options[key]) !== 'string' ? JSON.stringify(options[key]) : options[key])
	}

	const merged = Object.assign({}, params, defaultPOST, { body: params })
	const response = await fetch(APP_FEEDBACK_PERSONAL, merged)
	return await response.json()
}

const sendAnnounces = async (options) =>{
	let params = new URLSearchParams()
	for (let key in options) {
		params.append(key, typeof(options[key]) !== 'string' ? JSON.stringify(options[key]) : options[key])
	}

	const merged = Object.assign({}, params, defaultPOST, { body: params })
	const response = await fetch(APP_ANNOUNCE, merged)
	return await response.json()
}

const updateUser = async (options) => {
	const merged = Object.assign({}, defaultGET, {body: queryString.stringify(options, {arrayFormat: 'bracket'})})
	const response = await fetch(APP_SET_USER, merged)
	return await response.json()
}

export {
	allowaccess,
	fetchLogout,
	fetchRegistration,
	sendFeedback,
	getUser,
	getAuth,
	updateUser,
	sendAnnounces,
	login,
	sendFeedbackPersonal
}